import React from 'react';

interface AIIconProps {
  loading?: boolean;
  style?: React.CSSProperties;
}

const AIIcon: React.FC<AIIconProps> = ({ loading = false, style = {} }) => {
  return (
    <div 
      className="ai-icon-wrapper"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '20px',
        height: '20px',
        marginRight: '8px',
        ...style
      }}
    >
      <svg
        className="ai-icon-svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        style={{
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          opacity: loading ? 0.7 : 1,
        }}
      >
        <defs>
          <linearGradient id="ai-sparkle-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fff" />
            <stop offset="100%" stopColor="#f0f0ff" />
          </linearGradient>
        </defs>
        
        {/* Main sparkle star */}
        <path
          className="ai-sparkle-main"
          d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z"
          fill="url(#ai-sparkle-gradient)"
          style={{
            transformOrigin: 'center',
            animation: loading ? 'sparkle-pulse 1.5s ease-in-out infinite' : 'none',
          }}
        />
        
        {/* Small sparkle top-right */}
        <path
          className="ai-sparkle-small-1"
          d="M19 3L19.5 5L21.5 5.5L19.5 6L19 8L18.5 6L16.5 5.5L18.5 5L19 3Z"
          fill="url(#ai-sparkle-gradient)"
          style={{
            transformOrigin: '19px 5.5px',
            animation: loading ? 'sparkle-twinkle 1s ease-in-out infinite 0.2s' : 'none',
          }}
        />
        
        {/* Small sparkle bottom-right */}
        <path
          className="ai-sparkle-small-2"
          d="M20 14L20.4 15.6L22 16L20.4 16.4L20 18L19.6 16.4L18 16L19.6 15.6L20 14Z"
          fill="url(#ai-sparkle-gradient)"
          style={{
            transformOrigin: '20px 16px',
            animation: loading ? 'sparkle-twinkle 1s ease-in-out infinite 0.5s' : 'none',
          }}
        />
      </svg>
      
      <style>{`
        @keyframes sparkle-pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.1); opacity: 0.8; }
        }
        
        @keyframes sparkle-twinkle {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(0.6); opacity: 0.4; }
        }
        
        @keyframes sparkle-rotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        .ai-icon-wrapper:hover .ai-sparkle-main {
          animation: sparkle-pulse 0.8s ease-in-out infinite !important;
        }
        
        .ai-icon-wrapper:hover .ai-sparkle-small-1 {
          animation: sparkle-twinkle 0.6s ease-in-out infinite !important;
        }
        
        .ai-icon-wrapper:hover .ai-sparkle-small-2 {
          animation: sparkle-twinkle 0.6s ease-in-out infinite 0.3s !important;
        }
        
        .ai-icon-wrapper:hover .ai-icon-svg {
          transform: scale(1.15) rotate(5deg);
          filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.6));
        }
      `}</style>
    </div>
  );
};

export default AIIcon;
